import { render } from "./SettingsIssuancePage.vue?vue&type=template&id=94591954"
import script from "./SettingsIssuancePage.vue?vue&type=script&lang=js"
export * from "./SettingsIssuancePage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__